import React, { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/GlobalContext';
import { Card, Statistic } from 'semantic-ui-react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { Link } from "react-router-dom";
import { easeQuadInOut } from 'd3-ease';
import AnimatedProgressProvider from '../../Provider/AnimatedProgressProvider';
import Utility from '../../../Utility';
import MomentCustomer from "../../MomentCustomer/MomentCustomer";

/**
 * Components CheckinBooking
 * Widget pour le dashboard
 * @param {object} props.completionRate
 */
const CheckinBooking = props => {
  const [globalContext] = useContext(GlobalContext);
  const siteMap = Utility.getSiteMap(globalContext.translations);
  const [bookingFolderIdState, setBookingFolderIdState] = useState(0);
  const [rateState, setRateState] = useState(0);

  useEffect(() => {
    if(props.completionRate !== undefined && props.completionRate !== null) {
      if(props.completionRate.folderList !== undefined && props.completionRate.folderList !== null) {
        for(let [, bookingFolder] of Object.entries(props.completionRate.folderList)) {
          if(bookingFolder !== undefined && bookingFolder !== null) {
            if(bookingFolder.bookingFolderId !== undefined && bookingFolder.bookingFolderId !== null) {
              if(bookingFolder.rate !== undefined && bookingFolder.rate !== null) {
                setBookingFolderIdState(bookingFolder.bookingFolderId);
                setRateState(bookingFolder.rate);
              }
            }
          }
        }
      }
    }
  }, [props.completionRate.bookingFolderId]);

  const getColorStatistic = (nameClass) => {
    let dataColor = ['green', 'red', 'yellow'];
    if (nameClass === false) {
      dataColor = ['rgb(33,186,69)', 'rgb(219,40,40)', 'rgb(251,189,8)'];
    }

    let color = dataColor[0];
    
    if (rateState < 40) {
      color = dataColor[1];
    } else if(rateState < 60) {
      color = dataColor[2];
    }

    return color;
  }

  return (
    <Card
      style={{ height: "300px" }}
      centered as={Link}
      to={`${Utility.getUrlBaseName()}/${siteMap.checkin.codePage}/${bookingFolderIdState}`}
      onClick={() => props.setActiveItemMenu(siteMap.checkin.codePage)}
    >
      <Card.Header  style={{textAlign: 'center'}}>
        <h4 className="ui header py-3">{globalContext.translations.headerCompletion} <MomentCustomer format="Do MMMM">{props.booking.arrivalDate}</MomentCustomer></h4>
      </Card.Header>
      <Card.Content extra style={{textAlign: 'center', height: 'calc( 100% - 68px)'}}>
        <div style={{ width: '60%', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>
          <AnimatedProgressProvider
            valueStart={0}
            valueEnd={rateState}
            duration={1.5}
            easingFunction={easeQuadInOut}
          >
            {value => {
              const roundedValue = Math.round(value);
              return (
                <CircularProgressbarWithChildren className="dashboard-completion" strokeWidth={4} valueStart={0} valueEnd={100} value={roundedValue}
                  styles={{ path: { transition: 'none', stroke: getColorStatistic(false) } }}
                >
                  <Statistic size="tiny" color={getColorStatistic(true)}>
                    <Statistic.Value>{roundedValue} %</Statistic.Value>
                    <Statistic.Label className="p-2" style={{fontSize: '0.8em'}}>{globalContext.translations.completion}</Statistic.Label>
                  </Statistic>
                </CircularProgressbarWithChildren>
              );
            }}

          </AnimatedProgressProvider>
        </div>
      </Card.Content>
      <Card.Content textAlign="center" extra style={{ height: 68 }}>
        {globalContext.translations.completionMessage}
      </Card.Content>
    </Card>
  )
}

export default CheckinBooking;